import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {CoreApiService} from "../../../core/service/core-api.service";
import {InsuranceDocumentDto} from "../../user-insurance/types/ds-user-added-insurance.types";
import {ContractsRequestDto, ContractsRuntimeDto, ContractsRuntimeInsuranceDto} from "../types/contracts.types";
import {BinaryDocumentServiceInterface} from "../../../core/service/binary-document-service.interface";


@Injectable({ providedIn: 'root' })
export abstract class ContractApiService implements BinaryDocumentServiceInterface{

  endPoint: string = "mvseu/eu/contracts"

  constructor(
    protected coreApiService: CoreApiService) {
  }

  public list(request: ContractsRequestDto): Observable<ContractsRuntimeDto> {
    return this.coreApiService.post(request,`${this.endPoint}/list`);
  }

  public getContract(id: number): Observable<ContractsRuntimeInsuranceDto> {
    return this.coreApiService.get(`${this.endPoint}/${id}`);
  }

  public getContractDocumentBase64(contractId: number, documentId: number): Observable<InsuranceDocumentDto> {
    return this.coreApiService.get(`${this.endPoint}/contractDocument/${contractId}/${documentId}/base64`);
  }

  public getDocumentBinary(contractId: number, documentId: number): Observable<Blob | string> {
    return this.coreApiService.getDocumentBinary(`${this.endPoint}/contractDocument/${contractId}/${documentId}/$`);
  }


}
